import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    showBuyPlanModal: false,
};

const uiSlice = createSlice({
    name: "ui",
    initialState,
    reducers: {
        openBuyPlanModal: (state) => {
            state.showBuyPlanModal = true;
        },
        closeBuyPlanModal: (state) => {
            state.showBuyPlanModal = false;
        },
    },
});

export const {
    openBuyPlanModal,
    closeBuyPlanModal,
} = uiSlice.actions;

export default uiSlice.reducer;